module.exports = __webpack_public_path__ + "img/w20-cover.4540ac50.jpg";